import { iconSizes } from "./theme.mjs";
import { useTheme } from "./ThemeProvider.mjs";
import { useStyles } from "purse-styles";
import React from "react";
import { Focusable } from "react-aria-components";
import { jsx } from "react/jsx-runtime";
import { AlarmClock, AlertCircle, ArrowBigRightDash, ArrowUp, AtSign, AudioLines, BadgeCheck, Bell, BellOff, BookMarked, BookUser, Bot, BotMessageSquare, Building, Calendar, CalendarDays, CalendarRange, ChartColumnBig, ChartPie, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronsDownUp, ChevronsUpDown, CircleCheckBig, CircleDollarSign, CircleHelp, CirclePlus, CircleUser, CircleX, ClipboardCheck, Clock, Construction, Copy, Database, Download, EyeOff, FileCheck, FileClock, FileHeart, FileText, FileUser, Frown, Gauge, Globe, Grid2x2X, HandCoins, Headset, Hospital, IdCard, Image, Inbox, Info, Landmark, List, Lock, MapPin, MessageSquare, MessagesSquare, NotebookPen, Percent, Phone, PhoneCall, Plus, PointerOff, Receipt, Reply, Save, Search, Send, Settings, Shield, ShieldCheck, ShieldEllipsis, ShieldOff, ShieldX, SmartphoneNfc, Snail, Sparkles, SquarePen, Star, Stethoscope, TestTubeDiagonal, Thermometer, Trash, Trash2, TriangleAlert, UserPen, UserRoundSearch, Workflow, X } from "lucide-react";

//#region src/Icon.tsx
const icons = {
	AudioLines,
	AlertCircle,
	ArrowUp,
	FileUser,
	Hospital,
	BookMarked,
	FileText,
	Capital: Landmark,
	TestTube: TestTubeDiagonal,
	Globe,
	CircleUser,
	Phone,
	Check,
	ChevronDown,
	ChevronLeft,
	ChevronsDownUp,
	ChevronsUpDown,
	X,
	PhoneCall,
	Star,
	CircleDollarSign,
	Calendar,
	CalendarDays,
	CalendarRange,
	Reply,
	ShieldCheck,
	ShieldEllipsis,
	ShieldX,
	BadgeCheck,
	Gauge,
	UserPen,
	ShieldOff,
	PointerOff,
	Snail,
	Database,
	Download,
	BotMessageSquare,
	Workflow,
	Percent,
	Grid2x2X,
	Info,
	BookUser,
	Thermometer,
	Headset,
	CircleHelp,
	BellOff,
	SmartphoneNfc,
	ClipboardCheck,
	Clock,
	Frown,
	Lock,
	EyeOff,
	Construction,
	FileClock,
	NotebookPen,
	HandCoins,
	Inbox,
	Receipt,
	Stethoscope,
	Save,
	Trash,
	Sparkles,
	CircleCheckBig,
	Building,
	AtSign,
	IdCard,
	FileHeart,
	Copy,
	Search,
	Settings,
	Shield,
	List,
	MapPin,
	Bell,
	SquarePen,
	Image,
	Bot,
	ArrowBigRightDash,
	CirclePlus,
	Plus,
	MessageSquare,
	Send,
	ChevronRight,
	AlarmClock,
	TriangleAlert,
	CircleX,
	MessagesSquare,
	ChartColumnBig,
	ChartPie,
	UserRoundSearch,
	FileCheck,
	Trash2
};
/**
* Icon component that renders Lucide icons with theming support.
* Provides consistent sizing, coloring, and flex layout properties.
*/
const Icon = ({ name, size: sizeName = "md", fill: fillName, light, color: colorName = light ? "sand11" : "sand12", style: style$1, flex, basis, grow, shrink, alignSelf, focusable }) => {
	const theme = useTheme();
	const LucideIcon = icons[name];
	const color = theme.colors[colorName];
	const flexStyles = {
		flex: flex === true ? 1 : flex === false ? 0 : flex,
		flexBasis: basis,
		flexGrow: grow === true ? 1 : grow === false ? 0 : grow,
		flexShrink: shrink === true ? 1 : shrink === false ? 0 : shrink,
		alignSelf
	};
	const spanClassName = useStyles({
		width: iconSizes[sizeName],
		height: iconSizes[sizeName],
		...flexStyles
	});
	const fillStyles = fillName ? { fill: theme.colors[fillName] } : void 0;
	const element = /* @__PURE__ */ jsx("span", {
		className: spanClassName,
		"aria-label": name,
		style: {
			display: "inline-flex",
			placeItems: "center"
		},
		children: /* @__PURE__ */ jsx(LucideIcon, {
			width: "100%",
			height: "100%",
			color,
			...fillStyles,
			style: style$1
		})
	});
	if (focusable) return /* @__PURE__ */ jsx(Focusable, { children: element });
	return element;
};

//#endregion
export { Icon };